import { useContext } from "react";
import { VideoSurveyInventoryContext } from "../context/VideoSurveyInventoryContext";

export const useVideoSurveyInventory = () => {
  const context = useContext(VideoSurveyInventoryContext);

  return context;
};
